import { __assign } from "tslib";
import { AxiosError } from 'axios';
export function getError(e) {
    var _a;
    return e instanceof Error
        ? {
            message: e.message || '',
            info: e instanceof AxiosError ? (_a = e.response) === null || _a === void 0 ? void 0 : _a.data : { error: e },
        }
        : e;
}
export function getPostEventBody(_a) {
    var eventType = _a.eventType, opts = _a.opts;
    return {
        eventType: eventType,
        payload: __assign({}, opts),
    };
}
